module.exports = __webpack_public_path__ + "images/emoji/arrow_down_small.54c0151ea2b7b9c0cfce.png";